import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { accountUrl } from '../../../constants/url-constants';
import { Account } from '../models/account.model';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private userIdentity: any;
  private authenticated = false;
  private authenticationState = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) { }

  fetch(): Observable<HttpResponse<Account>> {
    return this.http.get<Account>(accountUrl, { observe: 'response' });
  }

  save(account: any): Observable<HttpResponse<any>> {
    return this.http.post(accountUrl, account, { observe: 'response' });
  }

  authenticate(identity) {
    this.userIdentity = identity;
    this.authenticated = identity !== null;
    this.authenticationState.next(this.userIdentity);
  }

  hasAnyAuthority(authorities: string[]): boolean {
    if (
      !this.authenticated ||
      !this.userIdentity ||
      !this.userIdentity.authorities
    ) {
      return false;
    }

    for (const authority of authorities) {
      if (this.userIdentity.authorities.includes(authority)) {
        return true;
      }
    }

    return false;
  }

  identity(force = false): Promise<Account> {
    if (force) {
      this.userIdentity = undefined;
    }
    // check and see if we have retrieved the userIdentity data from the server.
    // if we have, reuse it by immediately resolving
    if (this.userIdentity) {
      return Promise.resolve(this.userIdentity);
    }

    // retrieve the userIdentity data from the server, update the identity object, and then resolve.
    return this.fetch()
      .toPromise()
      .then(response => {
        const account: Account = response.body;
        if (account) {
          this.userIdentity = account;
          this.authenticated = true;
        } else {
          this.userIdentity = null;
          this.authenticated = false;
        }
        this.authenticationState.next(this.userIdentity);
        return this.userIdentity;
      })
      .catch(err => {
        this.userIdentity = null;
        this.authenticated = false;
        this.authenticationState.next(this.userIdentity);
        return null;
      });
  }

  isAuthenticated(): boolean {
    return this.authenticated;
  }

  isIdentityResolved(): boolean {
    return this.userIdentity !== undefined;
  }

  getAuthenticationState(): Observable<any> {
    return this.authenticationState.asObservable();
  }

  getImageUrl(): string {
    return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
  }

  emitUserIdentity(obj) {
    this.authenticationState.next(obj);
  }
}
